import PropTypes from 'prop-types';
import { useRef } from 'react';
import classNames from 'classnames';
// import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJEffectPresetPreviewItem from './FJEffectPresetPreviewItem';
import FJSparkIcon from '../../../../assets/svg/re-star.svg?react';
import FJConstant from '../../../../constants/FJConstant';
import FJUtil from '../../../../util/FJUtil';

import styles from './FJAIPhotoEditorPresetList.module.less';

function FJAIPhotoEditorPresetList({ onChange, options, promptStatus }) {
    const scrollRef = useRef(null);

    return (
        <div
            className={classNames(styles.box, {
                [styles.disabled]: promptStatus === FJConstant.PROGRESS,
                [styles.ff]: FJUtil.getBrowser().includes('FF'),
                [styles.os]: FJUtil.getOS().includes('macOS'),
            })}
            data-browser={FJUtil.getBrowser()}
        >
            <div className={styles.effect_title}>
                {FJLocalStore._('try-these-effects')} <FJSparkIcon className={styles.spark_icon} />
            </div>
            <div className={styles.scroll} ref={scrollRef}>
                {options?.length > 0 &&
                    options.map(item => <FJEffectPresetPreviewItem key={item.id} item={item} onSelect={onChange} />)}
            </div>
        </div>
    );
}

FJAIPhotoEditorPresetList.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    options: PropTypes.array,
    promptStatus: PropTypes.string,
};

export default FJAIPhotoEditorPresetList;
